import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageDataService } from '../../../../Autofacets-Core/src/app/common-services/language-data.service';
import { ClientIpViewModel } from '../business-entities/client-ip-view-model';

@Injectable({
    providedIn: 'root'
})

export class LanguageService{
    constructor(private service : LanguageDataService) {
    }

    getAllLanguage(): Promise<any> 
    {
        return this.service.getAllLanguage();
    }

    getLocalizationData(languagCode: string): Observable<any>
    {
        return this.service.getLocalizationData(languagCode);
    }

    getClientIpData(ip: string): Observable<any>
    {
        return this.service.getClientIpData(ip);
    }

    addIpDetails(clientIpDetails: ClientIpViewModel) {
        return this.service.addClientIpDetails(clientIpDetails);
    }
}